export enum Action {
  Created = 'CREATED',
  Updated = 'UPDATED',
  Deleted = 'DELETED',
  Rejected = 'REJECTED',
  Restored = 'RESTORED',
}
